module.exports = __webpack_public_path__ + "static/media/clock2.39385d32.png";